<div class="w-100">
  <mwp-card-content-header [url]="apiUrl" />
  <div class="mt-3">
    <div class="content-container mb-3">
      <div class="title d-inline-flex w-100">
        <mwp-text-translate text="Agent Results" jsonKey="agentResults" />
      </div>
      <div class="content">
        <form [formGroup]="agentControlForm">
          <div class="d-flex flex-wrap row">
            <div class="col-3 pb-3">
              <mwp-dropdown [form]="agentControlForm" nameForControl="brokerId" [data]="brokers" keyText="name" keyValue="id" (emitSelected)="brokerChange($event)" labelName="Select Broker" />
            </div>
            @if (companies) {
            <div class="col-3 pb-3">
              @if (companies.length == 0) {
              <div>
                <mwp-text-translate text="No Companies For Broker" jsonKey="companyAssignNoCompaniesForBroker" />
              </div>
              }
              @if (companies.length > 0) {
              <div>
                <mwp-dropdown [form]="agentControlForm" nameForControl="companyID" [data]="companies" keyText="companyName" keyValue="companyID" (emitSelected)="companyChange($event)" labelName="Select Company" />
              </div>
              }
            </div>
            }
          </div>
        </form>

        @if (agentForm) {
        <div>
          <div class="mb-3">
            <mwp-table-formarray [form]="agentForm" [arrayName]="agentFormArrayName" [tableColumns]="agentColumns" [dataSource]="agentMatTableData" />
          </div>
          @if (!isAssign) {
          <div class="d-inline-flex justify-content-end w-100 p-3">
            @if (agentForm) {
            <button class="mwp-button-delete me-4" [disabled]="!agentForm.valid" (click)="unassignAgents()">
              <mwp-text-translate text="Unassign Agents" jsonKey="agentAssignUnassignAgents" />
            </button>
            }
            <button class="mwp-button-save" [disabled]="!selectedCompanyId" (click)="buildAssignForm()">
              <mwp-text-translate text="Assign Agents" jsonKey="companyAssignAssignAgents" />
            </button>
          </div>
          }
          @if (isAssign) {
          <div class="d-inline-flex justify-content-end w-100 p-3">
            <button class="mwp-button-delete me-4" (click)="buildUnassignForm()">
              <mwp-text-translate text="Unassign Agents" jsonKey="companyAssignUnassignAgents" />
            </button>
            <button class="mwp-button-save" [disabled]="!agentForm.valid" (click)="assignAgents()">
              <mwp-text-translate text="Assign Agents To Company" jsonKey="agentAssignAssignAgentsToCompany" />
            </button>
          </div>
          }
        </div>
        }
      </div>
    </div>
  </div>